import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import i18n from '../i18n';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setIsLoading(true);
    setError(null);

    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    try {
      const response = await fetch(`${baseUrl}/api/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const json = await response.json();

      if (!response.ok) {
        setIsLoading(false);
        setError(json.error);
        return null; // Return null if login fails
      }

      // Save the user to local storage
      localStorage.setItem('user', JSON.stringify(json));

      // Update the auth context
      dispatch({ type: 'LOGIN', payload: json });


      // Set i18n language if user has a language preference (top-level)
      if (json.language && i18n.language !== json.language) {
        i18n.changeLanguage(json.language);
      }

      setIsLoading(false);
  return json; // Return the user object (top-level fields)
    } catch (err) {
      setIsLoading(false);
      setError('Something went wrong. Please try again.');
      return null; // Return null if an error occurs
    }
  };

  return { login, isLoading, error };
};